import React from "react"
import { ThemeProvider } from "styled-components"
import themes from "./themes"

const theme = {
  breakpoints: {
    mobile: 0,
    tablet: 769,
    desktop: 1025,
    widescreen: 1216,
    fullhd: 1408,
    mahoosive: 1600
  }
}

const PostcardThemeProvider = (props) => {
  const buildTheme = Object.assign(theme, themes["campleaders"], props.theme)

  return <ThemeProvider theme={buildTheme}>{props.children}</ThemeProvider>
}

export default PostcardThemeProvider
